// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"8fefbbe8","209":"665a1b0f","717":"d31deb92","972":"0dc20cf9"}[chunkId] + ".chunk.js";
};